import React, { useState, useEffect } from 'react';
import MontrealMap from './MontrealMap';
import ArticleGrid from './ArticleGrid';
import { montrealPins } from '../data/pins';

const ExplorePage = ({ activeTab, setActiveTab }) => {

  useEffect(() => {
    // Add class to body to hide background pattern
    document.body.classList.add('explore-page-active');
    
    return () => {
      document.body.classList.remove('explore-page-active');
    };
  }, []);

  return (
    <div className="explore-page">
      <div className="explore-content">
        {activeTab === 'map' ? (
          <MontrealMap pins={montrealPins} />
        ) : (
          <ArticleGrid pins={montrealPins} />
        )}
      </div>
    </div>
  );
};

export default ExplorePage;